import { Stripe } from "@stripe/stripe-js";
import React, { ReactElement, useState } from "react";
import { MeasurementPeriodResponse } from "../../../models/MeasurementPeriod";
import BaseModal from "../../shared/BaseModal";
import Button from "../../shared/Button";
import { Props as FlushMessageProps } from "../../shared/FlushMessage";
import PlansImage from "../../shared/images/plans.png";

interface Props {
  measurementPeriod: MeasurementPeriodResponse;
  stripePromise: Promise<Stripe | null>;
  onReturn: () => void;
  onClose: () => void;
  beforeSave: () => void;
  afterSave: () => void;
}

export default function CreditCardModalContent(props: Props): ReactElement {
  const {
    measurementPeriod,
    stripePromise,
    onReturn,
    onClose,
    beforeSave,
    afterSave,
  } = props;
  const [flushMessage, setFlushMessage] = useState<FlushMessageProps>();

  return (
    <>
      <BaseModal.Body flushMessage={flushMessage}>
        <div>
          <div className="p-5 pb-10">
            <div>
              ご希望のプランをお選びいただき、以下の決済用URLよりお支払いをお願いいたします。
            </div>
            <div>
              {[
                {
                  title: "ライトプラン（5,500円/税込）",
                  url: "https://cclabo-lightplan25.peatix.com",
                },
                {
                  title: "ベーシックプラン（16,500円/税込）",
                  url: "https://cclabo-basicplan25.peatix.com",
                },
                {
                  title: "ベーシックプラン2回目（0円/税込）",
                  url: "https://cclabo-basicplan25.peatix.com",
                },
                {
                  title: "プレミアムプラン（55,000円/税込）",
                  url: "https://cclabo-premiumplan.peatix.com",
                },
              ].map((plan) => (
                <>
                  <div className="mt-3">{`▼ ${plan.title}`}</div>
                  <div>
                    <a href={plan.url} target="_blank" rel="noreferrer">
                      {plan.url}
                    </a>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div>
            <div>
              <img src={PlansImage} alt="plans" className="w-full" />
            </div>
          </div>
        </div>
      </BaseModal.Body>
      <BaseModal.Footer className="flex justify-between items-center">
        <div>
          <Button
            onClick={onReturn}
            title="戻る"
            className="opacity-75 tex-xs px-2 py-1"
          />
        </div>
        <div>
          <Button
            title="閉じる"
            className="sub-button px-3 py-1"
            onClick={onClose}
          />
        </div>
      </BaseModal.Footer>
    </>
  );
}
